import { IconProps } from 'interfaces';
import COLOR from 'constants/color';
import { isDarkMode } from 'utils/validators';

const FilterHorizontal = ({
  className = '~w-5/6 ~h-5/6',
  fill = COLOR.GRAY['900'],
  fillDarkMode = COLOR.PRIMARY.DARK_500
}: IconProps) => {
  const fillColor = isDarkMode() ? fillDarkMode : fill;

  return (
    <svg
      className={className}
      viewBox='0 0 23 23'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      preserveAspectRatio='xMidYMid meet'>
      <path
        d='M2.875 6.7085H5.75'
        stroke={fillColor}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M2.875 16.2915H8.625'
        stroke={fillColor}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M17.25 16.2915H20.125'
        stroke={fillColor}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14.375 6.7085H20.125'
        stroke={fillColor}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.75 6.7085C5.75 5.81544 5.75 5.36892 5.8959 5.01668C6.09043 4.54705 6.46356 4.17392 6.93319 3.97939C7.28542 3.8335 7.73195 3.8335 8.625 3.8335C9.51805 3.8335 9.96456 3.8335 10.3168 3.97939C10.7864 4.17392 11.1596 4.54705 11.3541 5.01668C11.5 5.36892 11.5 5.81544 11.5 6.7085C11.5 7.60155 11.5 8.04807 11.3541 8.40031C11.1596 8.86994 10.7864 9.24307 10.3168 9.4376C9.96456 9.5835 9.51805 9.5835 8.625 9.5835C7.73195 9.5835 7.28542 9.5835 6.93319 9.4376C6.46356 9.24307 6.09043 8.86994 5.8959 8.40031C5.75 8.04807 5.75 7.60155 5.75 6.7085Z'
        stroke={fillColor}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M11.5 16.2915C11.5 15.3984 11.5 14.9519 11.6459 14.5997C11.8404 14.1301 12.2136 13.7569 12.6832 13.5624C13.0354 13.4165 13.4819 13.4165 14.375 13.4165C15.2681 13.4165 15.7146 13.4165 16.0668 13.5624C16.5364 13.7569 16.9096 14.1301 17.1041 14.5997C17.25 14.9519 17.25 15.3984 17.25 16.2915C17.25 17.1846 17.25 17.6311 17.1041 17.9833C16.9096 18.4529 16.5364 18.8261 16.0668 19.0206C15.7146 19.1665 15.2681 19.1665 14.375 19.1665C13.4819 19.1665 13.0354 19.1665 12.6832 19.0206C12.2136 18.8261 11.8404 18.4529 11.6459 17.9833C11.5 17.6311 11.5 17.1846 11.5 16.2915Z'
        stroke={fillColor}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default FilterHorizontal;
